import React from 'react';

function NumberIcon(props) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='3'
        y='3'
        width='18'
        height='18'
        rx='2'
        stroke='#565F67'
        strokeWidth='2'
      />
      <path
        d='M7.33325 10.25L16.6666 10.25'
        stroke='#565F67'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.33325 13.75L16.6666 13.75'
        stroke='#565F67'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.8334 6.75L9.66675 17.25'
        stroke='#565F67'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.3334 6.75L13.1667 17.25'
        stroke='#565F67'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default NumberIcon;
